import { buildQrCodeUrl } from '../../constants/depositConstants';

export default function AddressQrCode({ value, size = 200, alt = '地址二維碼' }) {
  if (!value) {
    return null;
  }
  return (
    <img
      className="deposit-qr"
      src={buildQrCodeUrl(value, size)}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
    />
  );
}
